/*
 予防接種
 */
import api from './api'

export default function vaccination () {

	const myapp = new Vue({
		delimiters: ['${', '}'],
		el: '#v-vaccination',
		data () {
			return {
				viewType: 'table', // table or list
				vaccinations: null,
				distincts: null,
				institutions: null,

				supportSticky: (() => {
					const el = document.createElement('div')
					el.style.position = 'sticky'
					if (el.style.position === 'sticky') {
						return true
					}
					el.style.position = '-webkit-sticky'
					if (el.style.position === '-webkit-sticky') {
						return true
					}
					return false
				})(),

				scrollX: 0,
			}
		},
		computed: {
			hasTable () {
				return !!(this.vaccinations && this.institutions)
			},
			sortedVaccinations () {
				return Object.values(this.vaccinations).sort((a, b) => a.sort - b.sort)
			},
			vaccinationInstitutions () {
				if (!this.vaccinations || !this.institutions) {
					return null
				}
				const institutions = this.institutions
					.filter(institution => institution.vaccinations)
					.sort((a, b) => a.districts.id - b.districts.id)
				return institutions
			},
			listInstitutions () {
				if (!this.vaccinationInstitutions) {
					return null
				}
				const districts = []
				const institutionGroups = {}
				this.vaccinationInstitutions.forEach(institution => {
					const id = institution.districts.id
					if (!institutionGroups[id]) {
						districts.push(id)
						institutionGroups[id] = {
							district: institution.district,
							institutions: []
						}
					}
					institutionGroups[id].institutions.push(institution)
				})
				return districts.map(id => institutionGroups[id])
			},
			tableLeft () {
				if (this.supportSticky || !this.scrollX) {
					return ''
				}
				return -this.scrollX + 'px'
			}
		},
		methods: {
			switchViewType (viewType) {
				this.viewType = viewType
			},
			districtFormat (district) {
				return district.replace(/地区$/, '')
			},
			hasVaccination (ids, id) {
				return ids ? (',' + ids + ',').indexOf(',' + id + ',') >= 0 : false
			},
			toggleListSec (evt) {
				const el = evt.target.parentNode
				const val = el.getAttribute('aria-expanded')
				el.setAttribute('aria-expanded', val !== 'true' ? 'true' : 'false')
			},
			vacNames (ids) {
				if (!ids || !this.vaccinations) {
					return ''
				}
				return ids.split(',').map(id => this.vaccinations[id].vaccination_name).join(' / ')
			},
		},
		created () {
			api.institutions.distincts().then(data => {
				this.distincts = data
			})
			api.institutions.vaccinations().then(data => {
				this.vaccinations = data
			})
			api.institutions().then(data => {
				this.institutions = data
			})

			window.addEventListener('scroll', evt => {
				this.scrollX = window.pageXOffset
			})
		},
	})

}